// Mock data for KayJax-style configurator

// Building style profiles with default configurations
export const buildingStyleProfiles = {
  carport: {
    id: 'carport',
    name: 'Carport',
    description: 'Open-sided vehicle protection',
    defaults: {
      width: 20,
      length: 21,
      legHeight: 8,
      roofStyle: 'regular',
      roofPitch: 3,
      leftEnd: 'open',
      rightEnd: 'open',
      frontSide: 'open',
      backSide: 'open',
    },
    widthRange: { min: 12, max: 24 },
    lengthRange: { min: 21, max: 41 },
    heightRange: { min: 6, max: 12 },
  },
  carport_30: {
    id: 'carport_30',
    name: "30' Carport",
    description: 'Extra-wide carport for multiple vehicles',
    defaults: {
      width: 30,
      length: 35,
      legHeight: 12,
      roofStyle: 'regular',
      roofPitch: 3,
      leftEnd: 'open',
      rightEnd: 'open',
      frontSide: 'top-3',
      backSide: 'top-3',
    },
    widthRange: { min: 26, max: 30 },
    lengthRange: { min: 21, max: 51 },
    heightRange: { min: 8, max: 14 },
  },
  carport_40_50: {
    id: 'carport_40_50',
    name: "40' UP TO 50'",
    description: 'Commercial-size carport for large equipment',
    defaults: {
      width: 40,
      length: 31,
      legHeight: 10,
      roofStyle: 'regular',
      roofPitch: 4,
      leftEnd: 'open',
      rightEnd: 'open',
      frontSide: 'open',
      backSide: 'open',
    },
    widthRange: { min: 40, max: 50 },
    lengthRange: { min: 26, max: 101 },
    heightRange: { min: 10, max: 16 },
  },
  rv_cover: {
    id: 'rv_cover',
    name: 'RV Cover',
    description: 'Extra-tall for RVs and motorhomes',
    defaults: {
      width: 14,
      length: 40,
      legHeight: 12,
      roofStyle: 'gable',
      roofPitch: 3,
      leftEnd: 'open',
      rightEnd: 'open',
      frontSide: 'top-3',
      backSide: 'top-3',
    },
    widthRange: { min: 12, max: 24 },
    lengthRange: { min: 26, max: 51 },
    heightRange: { min: 10, max: 16 },
  },
  garage: {
    id: 'garage',
    name: 'Garage',
    description: 'Fully enclosed garage with garage doors',
    defaults: {
      width: 24,
      length: 30,
      legHeight: 9,
      roofStyle: 'gable',
      roofPitch: 3,
      leftEnd: 'enclosed',
      rightEnd: 'enclosed',
      frontSide: 'enclosed',
      backSide: 'enclosed',
      sidingOrientation: 'horizontal',
      garageDoors: [
        { wall: 'leftEnd', width: 9, height: 8, position: 30 },
        { wall: 'leftEnd', width: 9, height: 8, position: 70 }
      ],
      walkDoors: [
        { wall: 'rightEnd', width: 3, height: 7, position: 12 }
      ],
    },
    widthRange: { min: 18, max: 40 },
    lengthRange: { min: 21, max: 50 },
    heightRange: { min: 8, max: 14 },
  },
  side_bay_garage: {
    id: 'side_bay_garage',
    name: 'Side Bay Garage',
    description: 'Garage with open side bay for equipment',
    defaults: {
      width: 24,
      length: 50,
      legHeight: 12,
      roofStyle: 'regular',
      roofPitch: 4,
      leftEnd: 'enclosed',
      rightEnd: 'enclosed',
      frontSide: 'enclosed',
      backSide: 'enclosed',
      garageDoors: [
        { wall: 'frontSide', width: 9, height: 10, position: 20 },
        { wall: 'frontSide', width: 9, height: 10, position: 50 },
        { wall: 'frontSide', width: 9, height: 10, position: 80 }
      ],
      walkDoors: [
        { wall: 'leftEnd', width: 3, height: 6.67, position: 50 }
      ],
    },
    widthRange: { min: 26, max: 40 },
    lengthRange: { min: 26, max: 51 },
    heightRange: { min: 9, max: 14 },
  },
  barn: {
    id: 'barn',
    name: 'Barn',
    description: 'Classic barn with center section and lean-tos on both sides',
    defaults: {
      width: 22,
      length: 30,
      legHeight: 12,
      roofStyle: 'gable',
      roofPitch: 3,
      leftEnd: 'open',
      rightEnd: 'open',
      frontSide: 'open',
      backSide: 'open',
      leftLean: 'lean_only',
      leftLeanWidth: 12,
      leftLeanLength: 30,
      leftLeanHeight: 9,
      rightLean: 'lean_only',
      rightLeanWidth: 12,
      rightLeanLength: 30,
      rightLeanHeight: 9,
    },
    widthRange: { min: 18, max: 40 },
    lengthRange: { min: 21, max: 60 },
    heightRange: { min: 10, max: 16 },
  },
  shop_port: {
    id: 'shop_port',
    name: 'Shop Port',
    description: 'Combo building: enclosed shop + open carport',
    defaults: {
      width: 20,
      length: 30,
      legHeight: 9,
      roofStyle: 'regular',
      roofPitch: 3,
      leftEnd: 'open',        // Carport side - open
      rightEnd: 'enclosed',   // Shop side - enclosed
      frontSide: 'partial',   // Last 10ft enclosed (shop side)
      backSide: 'partial',    // Last 10ft enclosed (shop side)
      enclosedLength: 10,     // Length of enclosed portion on RIGHT side
      enclosedSide: 'right',  // Which side is enclosed
      garageDoors: [
        { wall: 'divider', width: 9, height: 8, position: 50 }
      ],
      walkDoors: [
        { wall: 'rightEnd', width: 3, height: 6.67, position: 50 }
      ],
    },
    widthRange: { min: 18, max: 30 },
    lengthRange: { min: 24, max: 51 },
    heightRange: { min: 8, max: 12 },
  },
  single_slope: {
    id: 'single_slope',
    name: 'Single Slope Carport',
    description: 'Modern single-slope roof design',
    defaults: {
      width: 20,
      length: 21,
      legHeight: 8,
      roofStyle: 'single_slope',
      roofPitch: 3,
      leftEnd: 'open',
      rightEnd: 'open',
      frontSide: 'open',
      backSide: 'open',
    },
    widthRange: { min: 12, max: 30 },
    lengthRange: { min: 21, max: 51 },
    heightRange: { min: 7, max: 14 },
  },
};

// Array format for display
export const buildingStyles = Object.values(buildingStyleProfiles);

export const installationSurfaces = [
  { id: 'soil', name: 'Soil' },
  { id: 'gravel', name: 'Gravel' },
  { id: 'asphalt', name: 'Asphalt' },
  { id: 'concrete', name: 'Concrete' },
];

export const roofStyles = [
  { id: 'regular', name: 'Regular Roof', pitch: 3 },
  { id: 'a_frame', name: 'A-Frame Horizontal', pitch: 4 },
  { id: 'boxed_eave', name: 'Boxed Eave', pitch: 3 },
  { id: 'vertical', name: 'Vertical Roof', pitch: 4 },
  { id: 'single_slope', name: 'Single Slope', pitch: 3 },
  { id: 'barn', name: 'Barn Style', pitch: 6 },
];

export const colors = {
  roof: [
    { name: 'Red', value: '#C41E3A' },
    { name: 'Burgundy', value: '#722F37' },
    { name: 'Blue', value: '#1E3A8A' },
    { name: 'Green', value: '#166534' },
    { name: 'Gray', value: '#6B7280' },
    { name: 'Charcoal', value: '#374151' },
    { name: 'White', value: '#FFFFFF' },
    { name: 'Black', value: '#1F2937' },
    { name: 'Tan', value: '#D4A574' },
    { name: 'Brown', value: '#78350F' },
  ],
  trim: [
    { name: 'White', value: '#FFFFFF' },
    { name: 'Red', value: '#C41E3A' },
    { name: 'Blue', value: '#1E3A8A' },
    { name: 'Black', value: '#1F2937' },
    { name: 'Gray', value: '#6B7280' },
    { name: 'Tan', value: '#D4A574' },
  ],
  sides: [
    { name: 'White', value: '#FFFFFF' },
    { name: 'Gray', value: '#9CA3AF' },
    { name: 'Charcoal', value: '#4B5563' },
    { name: 'Tan', value: '#D4A574' },
    { name: 'Clay', value: '#C4B7A6' },
    { name: 'Brown', value: '#78350F' },
    { name: 'Red', value: '#C41E3A' },
    { name: 'Blue', value: '#1E3A8A' },
    { name: 'Green', value: '#166534' },
  ],
  wainscot: [
    { name: 'None', value: 'none' },
    { name: 'White', value: '#FFFFFF' },
    { name: 'Gray', value: '#9CA3AF' },
    { name: 'Charcoal', value: '#4B5563' },
    { name: 'Tan', value: '#D4A574' },
    { name: 'Clay', value: '#C4B7A6' },
    { name: 'Brown', value: '#78350F' },
    { name: 'Red', value: '#C41E3A' },
    { name: 'Blue', value: '#1E3A8A' },
    { name: 'Green', value: '#166534' },
    { name: 'Black', value: '#1F2937' },
  ]
};

export const dimensions = {
  widths: [12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 34, 36, 38, 40, 42, 44, 46, 48, 50],
  lengths: [21, 26, 31, 36, 41, 46, 51, 56, 61, 66, 71, 76, 81, 86, 91, 96, 101],
  legHeights: [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
};

export const companyInfo = {
  name: 'KayJax Steel',
  phone: '813-924-5309',
  email: 'Info@KayJaxSteel.com',
  tagline: 'Florida Metal Building Contractors',
};
